import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React, { useEffect } from "react";
import { ReferenceArrayInput, ReferenceInput, required, SelectArrayInput, SelectInput } from "react-admin";
import { useWatch } from "react-hook-form";
import { NationalityType } from "utils/choices";

const DisciplineSessionExamSuccessRate = ({ handleParamChange }) => {
  const structuralUnitId = useWatch({ name: "structuralUnitId" });
  const academicYearIds = useWatch({ name: "academicYearIds" });

  // The report returns one row per academic year, so the filter is a list - drive the param from
  // the form value instead of the input's onChange, which hands over an event for a multi select.
  useEffect(() => {
    handleParamChange("academicYearIds", academicYearIds ?? null);
  }, [academicYearIds, handleParamChange]);

  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>
      {structuralUnitId && (
        <ReferenceInput
          source="disciplineId"
          reference={administrationRequests.getDisciplinesSelect()}
          filter={{ StructuralUnitId: structuralUnitId }}
        >
          <SelectInput
            label="Дисциплина"
            validate={required()}
            emptyText={false}
            onChange={e => handleParamChange("disciplineId", e.target.value)}
          />
        </ReferenceInput>
      )}
      <ReferenceArrayInput
        source="academicYearIds"
        reference={studentRequests.getAcademicYearsSelect()}
      >
        <SelectArrayInput
          label="Учебни години"
          validate={required()}
        />
      </ReferenceArrayInput>
      <ReferenceInput
        source="sessionType"
        reference={studentRequests.getAcademicSessionTypesSelect()}
        filter={{ sessionsOnly: true }}
      >
        <SelectInput
          label="Сесия"
          validate={required()}
          emptyText={false}
          onChange={e => handleParamChange("sessionType", e.target.value)}
        />
      </ReferenceInput>
      <SelectInput
        choices={NationalityType}
        source="nationalityType"
        label="Националност"
        emptyText={false}
        onChange={e => handleParamChange("nationalityType", e.target.value)}
      />
    </>
  );
};

export default DisciplineSessionExamSuccessRate;
